module.exports = __webpack_public_path__ + "img/chicken.75008fb0.png";